// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `h2 small[data-v-024c5add]{color:var(--color-warning);border:1px solid var(--color-warning);border-radius:16px;padding:0 9px}`, "",{"version":3,"sources":["webpack://./src/components/AdminSettings/MatterbridgeIntegration.vue"],"names":[],"mappings":"AAEC,0BACC,0BAAA,CACA,qCAAA,CACA,kBAAA,CACA,aAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
